import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generateAttendancePDF = ({
    employee,
    selectedMonth,
    summary,
    attendanceList
}) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();

    // Title
    doc.setFontSize(16);
    doc.text('Employee Monthly Attendance Report', pageWidth / 2, 15, { align: 'center' });

    // Employee Info
    doc.setFontSize(12);
    doc.text(`Employee: ${employee?.code} - ${employee?.name}`, 14, 30);
    doc.text(`Month: ${selectedMonth}`, 14, 38);

    // Summary Boxes
    //   autoTable(doc, {
    //     startY: 45,
    //     theme: 'grid',
    //     styles: { halign: 'center', fillColor: [245, 245, 245] },
    //     columnStyles: { 0: { fillColor: [240, 240, 240] } },
    //     head: [['Present Days', 'Absent Days', 'Leave Days', 'Half Day Leaves', 'Hour Permission']],
    //     body: [[
    //       summary.present_days,
    //       summary.absent_days,
    //       summary.leave_days,
    //       summary.half_days,
    //       summary.hour_permission
    //     ]]
    //   });
    autoTable(doc, {
        startY: 45,
        theme: 'grid',
        headStyles: {
            halign: 'center',
            fillColor: [230, 230, 230], // Light gray background
            textColor: [0, 0, 0],       // Black text
            fontStyle: 'bold'
        },
        styles: {
            halign: 'center'
        },
        head: [['Present Days', 'Absent Days', 'Leave Days', 'Half Day Leaves', 'Hour Permission']],
        body: [[
            summary.present_days,
            summary.absent_days,
            summary.leave_days,
            summary.half_days,
            summary.hour_permission
        ]]
    });

    // Attendance Table
    const formatDate = (val) => {
        if (!val || val.includes('0001-01-01')) return '-';
        const date = new Date(val);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const body = attendanceList.map((row) => [
        formatDate(row.att_date),
        row.status || '-',
        formatDate(row.check_in_date),
        row.check_in_time?.includes('0001') ? '-' : row.check_in_time || '-',
        formatDate(row.check_out_date),
        row.check_out_time?.includes('0001') ? '-' : row.check_out_time || '-'
    ]);

    autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        head: [['Date', 'Status', 'Check-In Date', 'Check-In Time', 'Check-Out Date', 'Check-Out Time']],
        body
    });

    doc.save(`Attendance_Report_${employee?.code}_${selectedMonth}.pdf`);
};
